import partnerFerrari from '@/assets/images/home/partners-ferrari.jpg'
import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'

export const Partners = () => {
  return (
    <section className={`${pageYPadding} ${pageXPadding}`}>
      <div
        className={`${pageMaxWidth} mx-auto flex flex-col md:flex-row md:items-center`}
      >
        <div className="flex flex-col gap-y-[14px] border-4  border-[#D4AF37] p-[40px] pb-[60px] md:w-1/2 md:shrink-0 md:border-0 md:p-0">
          <div className="flex justify-center md:justify-start ">
            <SectionTitle title="Our Partners" variant="primary" />
          </div>
          <p className="text-center font-nunito text-[12px] font-normal leading-[19.2px] text-[#000000]  md:text-start md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px]">
            {`Our clients are more than just customers—they’re our partners. We work closely with each one to ensure their vision is realized, delivering results that meet their expectations. Our clients trust us because we’re committed to doing the job right, every time.`}
          </p>
        </div>
        <div className="relative flex translate-y-[-20%] flex-col gap-y-[12px]  md:w-1/2 md:shrink-0 md:translate-y-0">
          <div className="absolute right-[80%] top-1/2 z-0 hidden w-screen -translate-y-1/2 border-[#D4AF37] md:block md:h-[150%] md:border-[6px] lg:h-[130%] lg:border-8"></div>
          <div className="z-10 flex w-full justify-center gap-x-[12px]">
            <PartnerLogo />
            <PartnerLogo />
            <PartnerLogo />
          </div>
          <div className="z-10 flex w-full justify-center gap-x-[12px]">
            <PartnerLogo />
            <PartnerLogo />
            <PartnerLogo />
          </div>
        </div>
      </div>
    </section>
  )
}

const PartnerLogo = () => {
  return (
    <img
      src={partnerFerrari}
      className="aspect-square h-full w-[28%] max-w-[140px] md:max-w-max"
    />
  )
}
